import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  Table,
  PageHeader,
  Button,
  Space,
  InputNumber,
  Checkbox,
  message,
  notification,
} from "antd";
// import { reverse } from "named-urls";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { companyCatalogAddSaga } from "./saga";
import * as selectors from "./selectors";
// import routes from "../../../../../routes";

const CompanyCatalogAdd = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: companyCatalogAddSaga });

  // BEING CONTEXTS
  const dispatch = useDispatch();
  const history = useHistory();
  const { companyId } = useParams();
  //END CONTEXTS

  // BEGIN STATES
  const [selectedTests, setSelectedTests] = useState([]);
  const [tableFilters, setTableFilters] = useState({
    categories: [],
    commodities: [],
    testCategories: [],
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  // BEGIN STATES

  // BEGIN SELECTORS
  const tests = useSelector(selectors.selectTests) || [];
  const fetchingCompanyDetails = useSelector(
    selectors.selectFetchingCompanyDetails
  );
  const fetchingDropdowns = useSelector(selectors.selectFetchingDropdowns);
  const fetchingTests = useSelector(selectors.selectFetchingTests);
  const companyDetails = useSelector(selectors.selectCompanyDetails) || {};
  const totalTests = useSelector(selectors.selectTestCount);
  const categories = useSelector(selectors.selectCommodityCategories) || [];
  const commodities = useSelector(selectors.selectCommodities) || [];
  const testCategories = useSelector(selectors.selectTestCategories) || [];
  const loading = useSelector(selectors.selectLoading);
  const error = useSelector(selectors.selectError);
  // END SELECTORS

  // BEGIN EFFECTS
  useEffect(() => {
    dispatch(
      actions.fetchCatalog({
        id: companyId,
        query: `page=1&limit=10`,
      })
    );
    dispatch(actions.fetchDropdown(["currency"]));
    dispatch(actions.fetchCompanyDetails({ id: companyId }));
    dispatch(actions.fetchFilters({ id: companyId }));
  }, [dispatch, companyId]);

  useEffect(() => {
    if (error && error !== "") {
      notification.error({
        message: "Error Updating Catalog",
        description: error,
      });
    }
    setTimeout(() => {
      dispatch(actions.initializeError());
    }, 1500);
  }, [error, dispatch]);

  // END EFFECTS

  const tableData = tests.map((test) => ({
    category: test?.commodityCategory?.name,
    commodity: test?.commodity?.name,
    parameter: test?.parameter,
    testCategory: test?.testCategory?.name,
    currency: test?.currency,
    price: test?.price,
    key: test._id,
  }));

  const onSuccess = () => {
    // history.push(
    //   reverse(`${routes.backOffice.companies.details.catalog}`, { companyId })
    // );
    message.success("Tests added to catalog!");
    setSelectedTests([]);
    dispatch(
      actions.fetchCatalog({
        id: companyId,
        query: `page=${currentPage}&limit=${pageSize}`,
      })
    );
    dispatch(actions.fetchDropdown(["currency"]));
    dispatch(actions.fetchCompanyDetails({ id: companyId }));
    dispatch(actions.fetchFilters({ id: companyId }));
  };

  const onFailure = () => {};

  const handleAddTests = () => {
    let checkForNullPrice = false;

    selectedTests.forEach((test) => {
      if (test.price === null) checkForNullPrice = true;
    });
    if (!checkForNullPrice) {
      const payloadData = {
        id: companyId,
        data: selectedTests,
        onSuccess,
        onFailure,
      };

      dispatch(actions.updateCatalog(payloadData));
    } else {
      notification.error({
        message: "Please add value for the price of the selected test",
      });
    }
  };

  const getCommodityCategoryFilters = () => {
    if (!categories?.length) return [];
    let availableCategories = categories;

    // handle relation with commodity
    if (tableFilters.commodities.length) {
      const possibleCategories = [];
      commodities.forEach((comm) => {
        if (
          tableFilters.commodities.indexOf(comm._id) !== -1 &&
          possibleCategories.indexOf(comm.category) === -1
        ) {
          possibleCategories.push(comm.category);
        }
      });
      availableCategories = categories.filter(
        (cat) => possibleCategories.indexOf(cat._id) !== -1
      );
    }

    // handle relation with test categories
    if (tableFilters.testCategories.length) {
      const fullTestCategories = testCategories.filter(
        (cat) => tableFilters.testCategories.indexOf(cat._id) !== -1
      );

      const possibleCategories = [];
      fullTestCategories.forEach((testCat) =>
        testCat.tests.forEach((test) => {
          if (possibleCategories.indexOf(test.commodityCategory === -1)) {
            possibleCategories.push(test.commodityCategory);
          }
        })
      );

      availableCategories = availableCategories.filter(
        (cat) => possibleCategories.indexOf(cat._id) !== -1
      );
    }

    const filter = availableCategories.map((cat) => ({
      text: cat.name,
      value: cat._id,
    }));
    return filter;
  };

  const getCommodityFilters = () => {
    if (!commodities?.length) return [];
    let possibleCommodities = commodities;

    // handle relation with categories
    if (tableFilters.categories.length) {
      possibleCommodities = commodities.filter(
        (comm) => tableFilters.categories.indexOf(comm.category) !== -1
      );
    }

    // handle relation with test categories
    if (tableFilters.testCategories.length) {
      const fullTestCategories = testCategories.filter(
        (cat) => tableFilters.testCategories.indexOf(cat._id) !== -1
      );

      const availableCommodities = [];
      fullTestCategories.forEach((testCat) =>
        testCat.tests.forEach((test) => {
          if (availableCommodities.indexOf(test.commodity === -1)) {
            availableCommodities.push(test.commodity);
          }
        })
      );

      possibleCommodities = possibleCommodities.filter(
        (cat) => availableCommodities.indexOf(cat._id) !== -1
      );
    }

    const filter = possibleCommodities.map((cat) => ({
      text: cat.name,
      value: cat._id,
    }));
    return filter;
  };

  const getTestCategoryFilters = () => {
    if (!testCategories?.length) return [];
    let availableCategories = testCategories;

    // handle relation with commodity
    if (tableFilters.commodities.length) {
      availableCategories = testCategories.filter((cat) => {
        // tableFilters.commodities
        const commoditiesKeys = {};
        cat.tests.forEach((test) => (commoditiesKeys[test.commodity] = ""));
        const availableCommodities = Object.keys(commoditiesKeys);
        const filtered = availableCommodities.filter(
          (comm) => tableFilters.commodities.indexOf(comm) !== -1
        );
        return filtered.length > 0;
      });
    }

    // handle relation with categories
    if (tableFilters.categories.length) {
      availableCategories = availableCategories.filter((cat) => {
        const categoriesKeys = {};
        cat.tests.forEach(
          (test) => (categoriesKeys[test.commodityCategory] = "")
        );
        const availableCategories = Object.keys(categoriesKeys);
        const filtered = availableCategories.filter(
          (cat) => tableFilters.categories.indexOf(cat) !== -1
        );
        return filtered.length > 0;
      });
    }

    const filter = availableCategories.map((cat) => ({
      text: cat.name,
      value: cat._id,
    }));
    return filter;
  };

  const handleToggleAllTests = () => {
    const currentSelectedTests = [...selectedTests];
    if (selectedTests.length === tests.length) {
      // deselect all
      setSelectedTests([]);
    } else {
      // select all
      tests.forEach((test) => {
        const index = currentSelectedTests.findIndex(
          (el) => el.test === test._id
        );
        if (index === -1) {
          currentSelectedTests.push({
            test: test._id,
            price: test.price,
            currency: test.currency?._id,
          });
        }
      });
      setSelectedTests(currentSelectedTests);
    }
  };

  const handleToggleTest = (record) => {
    const currentSelectedTests = [...selectedTests];
    const index = currentSelectedTests.findIndex(
      (el) => el.test === record.key
    );
    if (index !== -1) {
      // remove
      currentSelectedTests.splice(index, 1);
    } else {
      currentSelectedTests.push({
        test: record.key,
        price: record.price,
        currency: record.currency?._id,
      });
    }
    setSelectedTests(currentSelectedTests);
  };

  const handleChange = (index, field, value) => {
    const currentSelectedTests = [...selectedTests];
    currentSelectedTests[index][field] = value;
    setSelectedTests(currentSelectedTests);
  };

  const columns = [
    {
      title: (
        <Checkbox
          onChange={handleToggleAllTests}
          checked={selectedTests.length === tests.length}
          indeterminate={
            selectedTests.length > 0 && selectedTests.length < tests.length
          }
        />
      ),
      dataIndex: "select",
      width: "5%",
      render: (value, record, index) => {
        return (
          <Checkbox
            onChange={() => handleToggleTest(record)}
            checked={
              selectedTests.findIndex((el) => el.test === record.key) !== -1
            }
          />
        );
      },
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      filters: getCommodityCategoryFilters(),
      filterMode: "menu",
      filterSearch: true,
      width: "15%",
    },
    {
      title: "Commodity",
      dataIndex: "commodity",
      key: "commodity",
      filters: getCommodityFilters(),
      filterMode: "menu",
      filterSearch: true,
      width: "20%",
    },
    {
      title: "Test Type",
      dataIndex: "testCategory",
      key: "testCategory",
      filters: getTestCategoryFilters(),
      filterMode: "menu",
      filterSearch: true,
      width: "20%",
    },
    {
      title: "Parameter",
      dataIndex: "parameter",
      key: "parameter",
      width: "20%",
    },
    {
      title: "Price",
      dataIndex: "price",
      editable: true,
      key: "price",
      width: "20%",
      render: (value, record) => {
        const index = selectedTests.findIndex((el) => el.test === record.key);
        return index !== -1 ? (
          <Space>
            {record.currency?.value}
            <InputNumber
              min={0}
              value={selectedTests[index].price}
              onChange={(val) => handleChange(index, "price", val)}
            />
          </Space>
        ) : (
          `${record.currency?.value} ${record.price}`
        );
      },
    },
  ];

  const handleBack = () => {
    history.goBack();
  };

  const handleTablePagination = (pagination, filters, sorter) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
    let query = `page=${pagination.current}&limit=${pagination.pageSize}`;
    const filterToSet = {
      categories: [],
      commodities: [],
      testCategories: [],
    };
    if (filters.category) {
      filterToSet.categories = filters.category;
      filters.category.forEach((cat) => {
        query += `&commodityCategory=${cat}`;
      });
    } else {
      filterToSet.categories = [];
    }
    if (filters.commodity) {
      filterToSet.commodities = filters.commodity;
      filters.commodity.forEach((el) => {
        query += `&commodity=${el}`;
      });
    } else {
      filterToSet.commodities = [];
    }
    if (filters.testCategory) {
      filterToSet.testCategories = filters.testCategory;
      filters.testCategory.forEach((el) => {
        query += `&testCategory=${el}`;
      });
    } else {
      filterToSet.testCategories = [];
    }
    setTableFilters(filterToSet);

    dispatch(
      actions.fetchCatalog({
        id: companyId,
        query,
      })
    );
  };

  return (
    <div style={{ height: "100%" }}>
      <PageHeader
        onBack={handleBack}
        ghost={false}
        title="Add Tests"
        subTitle={companyDetails.companyName}
        extra={[
          <Button key="4" type="primary" onClick={handleAddTests}>
            Update Catalog
          </Button>,
        ]}
      />
      <div
        style={{
          height: "calc(100vh - 137px)",
          overflowY: "auto",
          padding: 24,
        }}
      >
        <Table
          dataSource={tableData}
          columns={columns}
          loading={
            fetchingCompanyDetails ||
            fetchingTests ||
            fetchingDropdowns ||
            loading
          }
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalTests,
            showSizeChanger: true,
            disabled: tableData.length === 0 ? true : false,
          }}
          onChange={handleTablePagination}
        />
      </div>
    </div>
  );
};

export default CompanyCatalogAdd;
